<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 22 20"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 12.3045C16 11.9588 16 11.786 16.052 11.632C16.2032 11.1844 16.6018 11.0108 17.0011 10.8289C17.45 10.6244 17.6744 10.5222 17.8968 10.5042C18.1493 10.4838 18.4022 10.5382 18.618 10.6593C18.9041 10.8198 19.1036 11.1249 19.3079 11.373C20.2513 12.5188 20.7229 13.0918 20.8955 13.7236C21.0348 14.2334 21.0348 14.7666 20.8955 15.2764C20.6438 16.1979 19.8485 16.9704 19.2598 17.6854C18.9587 18.0511 18.8081 18.234 18.618 18.3407C18.4022 18.4618 18.1493 18.5162 17.8968 18.4958C17.6744 18.4778 17.45 18.3756 17.0011 18.1711C16.6018 17.9892 16.2032 17.8156 16.052 17.368C16 17.214 16 17.0412 16 16.6955V12.3045Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M6 12.3046C6 11.8694 5.98778 11.4782 5.63591 11.1722C5.50793 11.0609 5.33825 10.9836 4.99891 10.829C4.55001 10.6246 4.32556 10.5224 4.10316 10.5044C3.43591 10.4504 3.07692 10.9058 2.69213 11.3732C1.74875 12.519 1.27706 13.0919 1.10446 13.7237C0.965179 14.2336 0.965179 14.7668 1.10446 15.2766C1.3562 16.1981 2.15152 16.9705 2.74021 17.6856C3.11129 18.1363 3.46577 18.5475 4.10316 18.496C4.32556 18.478 4.55001 18.3757 4.99891 18.1713C5.33825 18.0167 5.50793 17.9394 5.63591 17.8281C5.98778 17.5221 6 17.131 6 16.6957V12.3046Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M18 10.5V8.5C18 4.63401 14.866 1.5 11 1.5C7.13401 1.5 4 4.63401 4 8.5V10.5"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
